
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
name: "quality-management-view",
components: { DatetimePlugin,Confirm, Grid, GridItem, Popup},
directives: {
TransferDom
},
data() {
return {
id: null,
selectModel:'base',
basicDto:{},
testTypeList:[{name:'入库检验',code:'STOCK_CHECK'},{name:'过程检验',code:'PROCESS_CHECK'},{name:'客户发现',code:'CUS_DISC'},{name:'其他',code:'OTHER'}],
statusList:[{name:'新建',code:'NEW_CREATE'},{name:'已发布',code:'DEPLOYED'},{name:'已作废',code:'CANCELLED'}],
testStatusList:[{name:'合格',code:'QUALIFIED'},{name:'让步接受',code:'CONCESSION'},{name:'不合格',code:'DISQUALIFIED'}],
isSupplier:false
}
},

methods: {
changeShow(list,i) {
if (list[i].contentShow) {
this.$set(list[i], 'contentShow', false);
return;
}
this.$set(list[i], 'contentShow', true);
},
getDetail(){
this.$loadingShow();
this.$get('/api/quality-table/'+this.id).then((data) => {
this.basicDto = data;
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
changeShowModel(str){
this.selectModel = str;
},
getPerson(){
this.$get('api/person/current').then((res) => {
if(res.userType === '0'){
this.isSupplier = true;
}else{
this.isSupplier = false;
}
})
}
},
mounted() {
this.id = this.$route.params.id;
this.getPerson();
this.getDetail();
},


}



// WEBPACK FOOTER //
// ./src/page/quality-management/quality-management-view.vue